export const ALERT_GRID_COLUMN_TYPE = {
  EXTERNAL: 'external',
  METRIC_COMBINATION: 'metric_combination',
  'SYSTEM|EVENT_STATISTICS': 'system|event_statistics',
  ETC: 'etc',
  TABLE: 'table',
} as const;
